import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { adminApi, formatApiError } from "@/lib/api";
import { LangToggle } from "@/components/LangToggle";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminReset() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await adminApi.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      setErr(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/login"><img src="/corp-logo.png" alt="Relax-MIS" className="h-10 w-auto" /></Link>
          <LangToggle variant="light" />
        </div>
      </header>
      <main className="max-w-md mx-auto px-6 py-16">
        <div className="rounded-xl border border-stone-200 shadow-sm p-8 bg-white">
          <h1 className="font-serif text-3xl text-stone-900 mb-4">Choose a new password</h1>
          {done ? (
            <div className="text-emerald-800 text-sm" data-testid="reset-success">Password updated — redirecting…</div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <Input
                type="password"
                placeholder="At least 8 characters"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                data-testid="reset-password"
                required
                minLength={8}
              />
              {err && <div className="text-red-600 text-sm" data-testid="reset-error">{err}</div>}
              <Button
                type="submit"
                disabled={busy || !token}
                className="w-full bg-emerald-800 hover:bg-emerald-900 text-amber-50"
                data-testid="reset-submit"
              >
                {busy ? "…" : "Update password"}
              </Button>
            </form>
          )}
          <div className="text-center mt-4">
            <Link to="/login" className="text-emerald-800 text-sm hover:text-emerald-900 underline underline-offset-4" data-testid="reset-back-link">
              Back to sign in
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
